<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CRow>
            <CCol lg="3">
              <CInput
                disabled
                label="Request Code"
                v-model="items.request_code"
              />
            </CCol>
            <CCol lg="3">
              <CInput disabled label="User Code" v-model="items.user_code" />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Customer Name"
                v-model="items.user_name"
              />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Date Inserted"
                v-model="items.date_inserted"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="3">
              <CInput
                disabled
                label="Nama Alamat"
                v-model="items.address_title"
              />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Nama Penerima"
                v-model="items.recipient_name"
              />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="No Telp Penerima"
                v-model="items.recipient_phone"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="3">
              <CInput disabled label="Provinsi" v-model="items.province_name" />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Kabupaten/Kota"
                v-model="items.regencies_name"
              />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Kecamatan"
                v-model="items.district_name"
              />
            </CCol>
            <CCol lg="3">
              <CInput
                disabled
                label="Kelurahan"
                v-model="items.villages_name"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="3">
              <CTextarea disabled label="Alamat" v-model="items.address" />
            </CCol>
            <CCol lg="3">
              <CTextarea
                disabled
                label="Catatan Di alamat"
                v-model="items.notes"
              />
            </CCol>
            <CCol lg="6">
              <div class="product-group">
                <label for="product_group">Lokasi Toko</label>
                <br />
                <i v-if="items.lat === null"
                  >Lokasi Toko tidak tersedia, pastikan konsumen memasukkan
                  koordinat lokasi alamat</i
                >
                <CImg
                  v-if="items.lat !== null"
                  :src="
                    staticMap +
                    items.lat +
                    ',' +
                    items.long +
                    '&markers=color:red|label:A|' +
                    items.lat +
                    ',' +
                    items.long +
                    '&format=png&visual_refresh=true' +
                    '?r=' +
                    unixTime
                  "
                />
              </div>
            </CCol>
          </CRow>

          <CRow v-if="items.status !== '1'">
            <CCol lg="3">
              <!-- <CInput disabled label="Status" v-model="items.status" /> -->
              <div class="form-group">
                <label for="user_group">Status</label>
                <model-select
                  class="form-control"
                  id="user_group"
                  :options="statusList"
                  v-model="$v.requestForm.status.$model"
                  :isError="$v.requestForm.status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.requestForm.status.$invalid"
                  class="invalid-feedback-custom"
                >
                  Status should be filled.
                </div>
              </div>
            </CCol>

            <CCol sm="3">
              <div v-if="requestForm.status == 1" class="form-group">
                <label for="freezer">Freezer</label>
                <model-select
                  class="form-control"
                  id="freezer"
                  :options="freezerList"
                  @input="filterSerialNumber"
                  v-model="$v.requestForm.freezer_code.$model"
                  :isError="$v.requestForm.freezer_code.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.requestForm.freezer_code.$invalid"
                  class="invalid-feedback-custom"
                >
                  Please select one
                </div>
              </div>
            </CCol>

            <CCol sm="3">
              <div v-if="requestForm.status == 1" class="form-group">
                <label for="serialNumber">Serial Number</label>
                <model-select
                  class="form-control"
                  id="serialNumber"
                  :options="serialList"
                  v-model="$v.requestForm.serial_number.$model"
                  :isError="$v.requestForm.serial_number.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.requestForm.serial_number.$invalid"
                  class="invalid-feedback-custom"
                >
                  Please select one
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              v-if="items.status !== '1'"
              color="success"
              title="Detail"
              :disabled="$v.requestForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Store Information</template>
            <StoreInformation
              :items="items"
              :is-loading="isLoading"
            ></StoreInformation>
          </CTab>
          <CTab>
            <template slot="title">User Document</template>
            <br />
            <UserDocument :items="items" :is-loading="isLoading"></UserDocument>
          </CTab>
          <CTab>
            <template slot="title">Questionnaire</template>
            <br />
            <Questionnaire
              :items="qa_items"
              :is-loading="isLoading"
            ></Questionnaire>
          </CTab>
          <CTab>
            <template slot="title">Freezer Information</template>
            <br />
            <FreezerInformation
              :items="my_freezer_information"
              :is-loading="isLoading"
            ></FreezerInformation>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import custom_validation from "@/templates/_customValidation.js";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";
import StoreInformation from "./tabs/StoreInformation";
import UserDocument from "./tabs/UserDocument";
import Questionnaire from "./tabs/Questionnaire";
import FreezerInformation from "./tabs/FreezerInformation";

export default {
  name: "UserRequestFreezerDetail",
  components: {
    GlobalTable,
    Loading,
    StoreInformation,
    UserDocument,
    Questionnaire,
    FreezerInformation,
  },
  data() {
    return {
      title: "User Request Freezer Detail",
      requestForm: tableInterfaces.user_freezer_request,
      items: [],
      qa_items: [],
      isLoading: false,
      activeTab: 0,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      showImages: "",
      preview: false,
      statusList: [],
      freezerList: [],
      serialList: [],
      my_freezer_information: [],
      staticMap:
        "https://maps.googleapis.com/maps/api/staticmap?size=800x200&zoom=12&key=AIzaSyB2sn-FVl6cqtSIg4dPSUjqGXWw1pfkmso&center=",
    };
  },
  validations() {
    if (this.requestForm.status == 1) {
      return custom_validation.detailRequestFreezerFormCustom.accepted;
    } else {
      return custom_validation.detailRequestFreezerFormCustom.rejected;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailIssue(id);
      this.getDropdown();
      
      this.resetForm();
    },
    back: function () {
      this.$router.go(-1);
    },
    getDropdown: function () {
      this.axios
        .get("/console/dropdown/user_freezer_request")
        .then((response) => {
          this.statusList = response.data.request_freezer_status;
        });
    },
    getDropdownFreezer: function (request_code) {
      this.axios.get("/console/dropdown/get_freezer/by-request/"+request_code).then((response) => {
        this.freezerList = response.data.data;
      });
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/request_freezer/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.my_freezer_information = response.data.my_freezer_information;
            this.requestForm.status = this.items.status;
            this.getDropdownFreezer(response.data.data.request_code);
            this.axios
              .get(
                "console/request_freezer/questioner/" +
                  response.data.data.request_code
              )
              .then((response) => {
                if (response.data.status === 2000) {
                  this.qa_items = response.data.data;

                  this.showInfoNotification({
                    title: this.title,
                    message: response.data.message,
                  });
                } else {
                  this.showErrorNotification({
                    title: this.title,
                    message: response.data.message,
                  });
                }
              });

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterSerialNumber: function () {
      this.requestForm.serial_number = null;
      this.serialList = [];
      this.axios
        .get("/console/dropdown/serial_number/" + this.requestForm.freezer_code)
        .then((response) => {
          this.serialList = response.data.data;
        });
    },
    previewImages: function (img) {
      this.showImages = "";
      this.preview = true;
      this.showImages = img;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.requestForm.request_code = this.items.request_code;
        this.requestForm.id = this.items.id;
        this.axios
          .post("console/request_freezer/process-request", this.requestForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Request Freezer Update Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Request Freezer Update Status");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    resetForm: function () {
      this.requestForm.status = null;
      this.requestForm.freezer_code = null;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
